// Read-only viewer for an insurance / licence / accreditation item,
// rendered as a modal. Primary use today is the archived-item deep-link
// flow (F3): the `?item=X` Alert banner → "View archived item" action
// opens this modal. The in-page view is the inline DetailExpand rendered
// below the row.
//
// Internally this is just a modal wrapper around InsuranceDetailExpand
// so there's a single read-only layout source of truth.

import Modal from "../../../common/Modal";
import Button from "../../../common/Button";
import InsuranceDetailExpand from "./InsuranceDetailExpand";
import type { Insurance } from "../../../../types";

interface InsuranceDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  item: Insurance | null;
}

export default function InsuranceDetailModal({
  isOpen,
  onClose,
  item,
}: InsuranceDetailModalProps) {
  if (!item) return null;
  const isArchived = !!item.archivedAt;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={
        isArchived
          ? "Insurance / licence (archived)"
          : "Insurance / licence"
      }
      maxWidth="sm:max-w-2xl"
    >
      <div className="space-y-4">
        <InsuranceDetailExpand item={item} />

        <div className="flex justify-end gap-3 pt-2">
          {isArchived && (
            <Button
              variant="secondary"
              disabled
              title="Unarchive to edit — coming soon (self-service)"
              aria-label="Unarchive to edit — coming soon (self-service)"
            >
              Unarchive to edit
            </Button>
          )}
          <Button variant="primary" onClick={onClose}>
            Close
          </Button>
        </div>
      </div>
    </Modal>
  );
}
